import * as Cesium from "cesium";
export var CesiumUtils;
(function (CesiumUtils) {
    function createPolyLine(positions, name, width, material, clampToGround, show, depthTest = true) {
        const polyLine = new Cesium.Entity({
            name: name,
            polyline: {
                positions: positions,
                width: width,
                clampToGround: clampToGround,
                material: material,
                show: show ?? true,
                depthFailMaterial: depthTest ? undefined : material,
            },
        });
        return polyLine;
    }
    CesiumUtils.createPolyLine = createPolyLine;
})(CesiumUtils || (CesiumUtils = {}));
//# sourceMappingURL=cesium-utils.js.map